<app-dropdown-select
  class="full-width-button"
  [options]="langOptions"
  [value]="currentLang()"
  variant="push-btn"
  (selectionChange)="onLangChange($event)">
</app-dropdown-select>
